import React from "react";
import { Card } from "@/components/ui/card";
import { Bot } from "lucide-react";
import { ReceiptRobotSection } from "@/components/inbox/ReceiptRobotSection";

/** Einstellungen → Integrationen: Automatischer Beleg-Abruf (Netflix, Swisscom, Meta Ads …) verwalten. */
export function SettingsReceiptRobotSection({ companyId }) {
  return (
    <Card className="p-5 border border-slate-200 bg-white" id="section-receipt-robot" data-testid="settings-receipt-robot-section">
      <div className="flex items-start gap-3 mb-4">
        <div className="h-9 w-9 rounded-lg bg-indigo-50 text-indigo-700 flex items-center justify-center flex-shrink-0">
          <Bot className="h-5 w-5" />
        </div>
        <div>
          <h2 className="text-sm font-medium text-slate-900">Beleg-Abruf aus Portalen (Roboter)</h2>
          <p className="text-xs text-slate-500 mt-1 max-w-2xl">
            Hier sind die gespeicherten Portal-Zugänge (Netflix, Swisscom, Google, Meta Ads …). Der Roboter holt Rechnungen automatisch,
            wenn im Bankabgleich eine passende Abbuchung erscheint. Zugang ändern = löschen und neu anlegen (Passwörter werden verschlüsselt gespeichert
            und nie angezeigt). Dieselbe Verwaltung finden Sie auch im Posteingang unter «Beleg-Portale».
          </p>
        </div>
      </div>
      {companyId ? <ReceiptRobotSection companyId={companyId} /> : <p className="text-xs text-slate-500">Bitte zuerst eine Firma wählen.</p>}
    </Card>
  );
}
